import EditorJS, { EditorConfig, ToolConstructable } from '@editorjs/editorjs'
import { useEffect, useRef, useState } from 'react'
import List from '@editorjs/list'
import Header from '@editorjs/header'
import { Link } from '@/js/editor/components/descriptionEditor/link.ts'

export const useEditor = (config: EditorConfig & { editorId: string }) => {
    const [isReady, setIsReady] = useState<boolean>(false)
    const editorInstance = useRef<EditorJS | undefined>(undefined)

    useEffect(() => {
        if (editorInstance.current) {
            return
        }

        editorInstance.current = new EditorJS({
            tools: {
                list: List as ToolConstructable,
                customLink: Link,
                header: Header as ToolConstructable,
            },
            onReady: () => {
                setIsReady(true)
            },
            placeholder: 'Individuell gestalteter Text...',
            minHeight: 0,
            ...config,
        })
    }, [config.editorId])

    return {
        editor: editorInstance.current,
        isReady,
    }
}
